/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchExperienceByDestinationParams {
  search_destination: string;
}

const buildSearchExperienceByDestinationParams = (destinations: string[]): SearchExperienceByDestinationParams => {
  const joinedDestinations = destinations.sort().join(',');
  return { search_destination: joinedDestinations };
};

/**
 * 発火タイミング：検索発火時
 * @param destinations カンマ区切りの目的地の文字列
 * @returns
 */
export const sendGAWabunkaSearchExperienceByDestinationEvent = (destinations: string) => {
  if (destinations === '') {
    return;
  }
  sendWabunkaGAEvent('search_experience_by_destination', buildSearchExperienceByDestinationParams(destinations.split(',')));
};
